/* ============================================================
   REGINA – Header / Navigation
   assets/section-header.js
   ============================================================ */
(function () {
  var header = document.querySelector('[data-header]');
  if (!header) return;

  var toggle = header.querySelector('[data-nav-toggle]');
  var panel = header.querySelector('[data-mobile-nav]');

  function openNav() {
    header.classList.add('nav-open');
    document.documentElement.classList.add('nav-locked');
    // Transparent-Zustand sofort aufheben: bei offenem Menü muss der
    // Header deckend sein (sonst scheint oben die Seite durch)
    header.classList.remove('at-top');
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', toggle.dataset.labelClose || 'Menü schließen');
    // Seite dahinter nicht scrollen lassen, solange das Vollbild-Menü offen ist
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }
  function closeNav() {
    header.classList.remove('nav-open');
    document.documentElement.classList.remove('nav-locked');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', toggle.dataset.labelOpen || 'Menü öffnen');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    // offene Untermenüs im Drawer wieder einklappen
    panel.querySelectorAll('details[open]').forEach(function (d) { d.open = false; });
    // Transparent-Zustand ggf. wiederherstellen (steht man noch ganz oben?)
    requestAnimationFrame(function () {
      window.dispatchEvent(new Event('scroll'));
    });
  }

  toggle.addEventListener('click', function () {
    header.classList.contains('nav-open') ? closeNav() : openNav();
  });

  // Klick auf einen echten Link (nicht das Accordion-Summary) schließt das Menü
  panel.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', closeNav);
  });

  // Escape schließt das Menü
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && header.classList.contains('nav-open')) closeNav();
  });

  // Klick außerhalb des Headers schließt das Menü
  document.addEventListener('click', function (e) {
    if (header.classList.contains('nav-open') && !header.contains(e.target)) closeNav();
  });

  // Beim Wechsel zurück auf Desktop-Breite Menüzustand zurücksetzen
  var mq = window.matchMedia('(min-width: 1081px)');
  mq.addEventListener('change', function (e) { if (e.matches) closeNav(); });

  // Shopify Theme-Editor: Abschnitt beim Bearbeiten sichtbar/geöffnet halten
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.contains(header)) closeNav();
  });

  /* ============================================================
     Transparent am Seitenanfang
     - ganz oben (scrollY nahe 0): Klasse .at-top -> transparent,
       Logo-Unterzeile ausgeblendet
     - sobald gescrollt: .at-top weg -> normaler Header
     Läuft eigenständig, damit es auch ohne Auto-Hide greift.
     ============================================================ */
  if (header.dataset.transparentTop === 'true') {
    var TOP_TApp = 12; // px Toleranz, ab hier gilt "nicht mehr ganz oben"
    var topTicking = false;
    function syncAtTop() {
      topTicking = false;
      // Bei offenem Menü NIE transparent – der at-top-Zustand wird
      // komplett unterbunden, damit Header + Overlay deckend sind.
      if (header.classList.contains('nav-open')) {
        header.classList.remove('at-top');
        return;
      }
      if (window.scrollY <= TOP_TApp) {
        header.classList.add('at-top');
      } else {
        header.classList.remove('at-top');
      }
    }
    syncAtTop();
    window.addEventListener('scroll', function () {
      if (!topTicking) {
        topTicking = true;
        requestAnimationFrame(syncAtTop);
      }
    }, { passive: true });
  }

  /* ============================================================
     Hide-on-Scroll mit Honig-Einblendung
     - runterscrollen: Header versteckt sich (ab Mindesttiefe)
     - minimalstes Hochscrollen: Header fährt weich wieder ein,
       begleitet vom Honig-Schimmer (falls aktiviert)
     ============================================================ */
  if (header.dataset.hideOnScroll === 'true' && header.dataset.sticky === 'true') {
    var lastY = window.scrollY;
    var ticking = false;
    var glintEnabled = header.dataset.honeyGlint === 'true';
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var UP_THRESHOLD = 2;     // px – "minimalstes" Hochscrollen reicht
    var DOWN_THRESHOLD = 6;   // px – kleines Zittern beim Runterscrollen ignorieren
    var MIN_DEPTH = 90;       // px – oberhalb davon wird nie versteckt

    // Da der Header jetzt "fixed" schwebt, muss der Seiteninhalt um die
    // Header-Höhe nach unten versetzt werden, sonst rutscht die erste
    // Section darunter. Höhe variiert je nach Breakpoint -> dynamisch.
    // Ausnahme: Im transparenten Modus soll der Inhalt bewusst UNTER dem
    // Header durchlaufen (Hero-Bild bis ganz oben) -> Spacer dauerhaft 0.
    // Damit der Hero-Text nicht hinter dem Header verschwindet, sorgt das
    // CSS dort für genügend oberen Innenabstand.
    var transparentTop = header.dataset.transparentTop === 'true';
    var spacer = null;
    function syncSpacerHeight() {
      var h = transparentTop ? 0 : header.offsetHeight;
      if (!spacer) {
        spacer = document.createElement('div');
        spacer.setAttribute('data-header-spacer', '');
        header.insertAdjacentElement('afterend', spacer);
      }
      spacer.style.height = h + 'px';
    }
    syncSpacerHeight();
    window.addEventListener('resize', syncSpacerHeight, { passive: true });

    function runGlint() {
      if (!glintEnabled || reduceMotion) return;
      header.classList.remove('honey-glint-run');
      // Reflow erzwingen, damit die Animation erneut starten kann
      void header.offsetWidth;
      header.classList.add('honey-glint-run');
    }

    function onScroll() {
      ticking = false;
      var y = window.scrollY;
      var delta = y - lastY;

      // Offenes Mobilmenü: Header niemals wegziehen
      if (header.classList.contains('nav-open')) { lastY = y; return; }

      if (y <= MIN_DEPTH) {
        // Nahe Seitenanfang: immer sichtbar, kein Schimmer-Spam
        header.classList.remove('header-hidden', 'header-revealed');
      } else if (delta > DOWN_THRESHOLD) {
        // Runterscrollen -> verstecken
        if (!header.classList.contains('header-hidden')) {
          header.classList.remove('header-revealed');
          header.classList.add('header-hidden');
        }
      } else if (delta < -UP_THRESHOLD) {
        // Hochscrollen -> weich einfahren + Schimmer
        if (header.classList.contains('header-hidden')) {
          header.classList.remove('header-hidden');
          header.classList.add('header-revealed');
          runGlint();
        }
      }
      lastY = y;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(onScroll);
      }
    }, { passive: true });

    header.addEventListener('animationend', function (e) {
      if (e.animationName === 'honeyGlint') header.classList.remove('honey-glint-run');
    });
  }
})();

/* ===== ENDE DER DATEI – section-header.js vollständig.
   Wenn du diesen Kommentar in Shopify siehst, ist alles angekommen. ===== */
